:host {
  display: block;
  overflow: auto;
  width: 100%;
  height: 100%;
  background-color: #1e1e1e;
}

.ͼo {
  font-size: 12px !important;
}